import { Pipe, PipeTransform } from '@angular/core';
import { ProductListingVariant } from 'src/app/products/models/product-listing.model';

@Pipe({ name: 'productListingPercentageSave', standalone: true })
export class ProductListingPercentageSavePipe implements PipeTransform {

  transform(productVariant: ProductListingVariant): string {
    const actualSellingPrice = productVariant.price_list?.recommended_offers?.applicable_amount;
    const mrp = Number((productVariant?.mrp?.toString())?.replace(/,/g, ''));
    const percentDiscount = ((mrp - actualSellingPrice) / mrp) * 100;
    return percentDiscount >= 1 ? percentDiscount.toFixed() + '% off' : '';
  }

}
